/**
 * Column classes shared by the Assets list and My Assets so both tables have the same
 * column widths and row height (every cell is at most 40px tall → 56px rows). Every
 * column but Brand / Model has a fixed width; Brand / Model takes the remaining space.
 * Short values never wrap, so on a narrow screen the table scrolls sideways instead of
 * squashing.
 */
export const ASSET_COL = {
  files: 'w-[112px] min-w-[112px]',
  code: 'w-[210px] min-w-[180px] whitespace-nowrap',
  category: 'w-[220px] min-w-[180px]',
  brandModel: 'min-w-[200px]',
  status: 'w-[180px] min-w-[170px] whitespace-nowrap',
  assignedTo: 'w-[180px] min-w-[150px]',
  warranty: 'w-[140px] min-w-[120px] whitespace-nowrap',
  actions: 'w-[120px] min-w-[110px] whitespace-nowrap text-right',
} as const;
